module.exports = __webpack_public_path__ + "static/media/img-perfect-timing@3x.0d85ea9d.png";